// extracted by mini-css-extract-plugin
export default {"timer":"Qm0qA","rank":"HEQmS"};